import { render, staticRenderFns } from "./ImportResource.vue?vue&type=template&id=d9ef04ce&scoped=true"
import script from "./ImportResource.vue?vue&type=script&lang=js"
export * from "./ImportResource.vue?vue&type=script&lang=js"
import style0 from "./ImportResource.vue?vue&type=style&index=0&id=d9ef04ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9ef04ce",
  null
  
)

export default component.exports